<template>
	<div class="clear-page">
		<el-dialog title="提示" customClass='tips-h5' :visible.sync="dialogVisible" :close-on-click-modal='false'
		 :close-on-press-escape='false' :show-close='false' width="80%">
			<span>是否清空缓存</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="determine">确 定</el-button>
			</span>
		</el-dialog>
		<div class="login-again" v-show="login" style="text-align: center;">
			<el-button size="small" type="primary" @click="loginAgain">重新登录</el-button>
		</div>
		
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dialogVisible: false,
				login:false
			}
		},
		mounted() {
			if(localStorage.getItem('logInfo')){
				this.dialogVisible = true;
			}else{
				this.login = true;
			}
		},
		methods:{
			determine() {
				this.$store.state.login = false;
				localStorage.removeItem('logInfo');
				this.dialogVisible = false;
				var date=new Date();
				date.setTime(date.getTime()-10000);
				var keys=document.cookie.split(";");
				console.log("需要删除的cookie名字："+keys);
				if (keys) {
					for (var i =  keys.length; i--;)
					  // document.cookie=keys[i]+"; expire="+date.toGMTString()+"; path=/";
					  document.cookie ="logInfo='';expires=" + date.toGMTString()+";";
				}
				// document.cookie = key + "=" + value + "; expires=" + oDate.toDateString();
				this.login = true;
			},
			loginAgain(){
				this.$router.push('/index');
			}
		}
		
	}
</script>

<style>
	.tips-h5 .el-dialog__body{
		padding:14px 20px;
	}
	
	.login-again{
		display: block;
		margin: 30px auto;
	}
</style>
